'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EntityMapper = exports.clearEntityCache = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.assureComponent = assureComponent;
exports.getComponentFromMapper = getComponentFromMapper;

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _site = require('../context/site');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var getNested = require('get-nested'); // tslint:disable-line:no-var-requires
var entityCache = new _map2.default();
var clearEntityCache = exports.clearEntityCache = function clearEntityCache() {
    return entityCache.clear();
};

var EntityMapper = exports.EntityMapper = function (_React$Component) {
    (0, _inherits3.default)(EntityMapper, _React$Component);

    function EntityMapper() {
        (0, _classCallCheck3.default)(this, EntityMapper);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EntityMapper.__proto__ || (0, _getPrototypeOf2.default)(EntityMapper)).apply(this, arguments));

        _this.state = {
            error: null
        };
        _this.lastAssuredProps = null;
        return _this;
    }
    /**
     * If this component exists in a tree that is invoked with the waitForHnData function, this function is invoked.
     * Only after the promise is resolved, the component will be mounted. To keep the data fetched here, we assign the
     * state to the hnContext provided by the DrupalPageContextProvider. This way, the state will be preserved trough
     * multiple renders.
     */


    (0, _createClass3.default)(EntityMapper, [{
        key: 'bootstrap',
        value: function bootstrap() {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', assureComponent(this.props));

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            /**
             * This function is almost the same as the componentDidUpdate in the DrupalPage.
             * Please check there for more comments, context and reference.
             */
            var lastRequest = this.lastRequest = (0, _symbol2.default)();
            if (this.isReady()) {
                this.lastAssuredProps = this.props;
                return;
            }
            (function () {
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return assureComponent(this.props);

                                case 2:
                                    if (!(lastRequest !== this.lastRequest)) {
                                        _context2.next = 4;
                                        break;
                                    }

                                    return _context2.abrupt('return');

                                case 4:
                                    if (this.isReady()) {
                                        _context2.next = 6;
                                        break;
                                    }

                                    throw new Error('The component cannot be loaded.');

                                case 6:
                                    this.lastAssuredProps = this.props;
                                    this.forceUpdate();

                                case 8:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));
            })().catch(function (error) {
                _this2.setState({ error: error });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.lastRequest = undefined;
        }
    }, {
        key: 'isReady',
        value: function isReady() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return typeof getComponentFromMapper(props) !== 'undefined';
        }
    }, {
        key: 'render',
        value: function render() {
            /**
             * This render function is also almost the same technique as the DrupalPage render.
             * Please check that function for comments.
             */
            if (this.state.error) {
                throw this.state.error;
            }
            var canRenderFromProps = this.isReady();
            var props = canRenderFromProps ? this.props : this.lastAssuredProps;
            if (!props) {
                return null;
            }
            var EntityComponent = getComponentFromMapper(props);
            if (EntityComponent === null) {
                return null;
            }
            // istanbul ignore next
            if (!EntityComponent) {
                throw new Error("We received data that we can't render. This shouldn't be possible.");
            }
            var data = props.site.getData(props.uuid);
            return React.createElement(EntityComponent, (0, _assign2.default)({ bundle: getBundle(data), paragraph: data, entity: data }, props.entityProps));
        }
    }]);
    return EntityMapper;
}(React.Component);

EntityMapper.propTypes = {
    asyncMapper: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func])]),
    entityProps: PropTypes.shape({}),
    mapper: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func, PropTypes.bool]),
    uuid: PropTypes.string.isRequired
};
EntityMapper.defaultProps = {
    asyncMapper: false,
    entityProps: {},
    mapper: false
};
var EntityMapperWrapper = React.forwardRef(function (props, ref) {
    return React.createElement(_site.SiteConsumer, null, function (site) {
        return React.createElement(EntityMapper, (0, _assign2.default)({}, props, { site: site, ref: ref }));
    });
});
exports.default = EntityMapperWrapper;
/**
 * This gets a component from some mapper data.
 * This can also be a promise resolving to a component.
 */

function getComponentOrPromiseFromMapper(props) {
    // This gets the entity from the site, based on the uuid.
    var entity = props.site.getData(props.uuid);
    // This should give back a bundle string, that is used in the mapper.
    var bundle = getBundle(entity);
    // If it's not an async mapper, we can just use the 'mapper' prop.
    if (!props.asyncMapper) {
        return {
            type: 'component',
            value: typeof props.mapper === 'function' ? props.mapper(entity, bundle) : props.mapper[bundle]
        };
    }
    // We check which style of the mapper it is.
    var entityComponentMapper = props.asyncMapper === true ? props.mapper : props.asyncMapper;
    var entityComponentResult = typeof entityComponentMapper === 'function' ? entityComponentMapper(entity, bundle) : entityComponentMapper[bundle];
    return {
        type: 'promise',
        value: entityComponentResult
    };
}
/**
 * This makes sure the data for this url is ready to be rendered.
 */
function assureComponent(props) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var component, entityComponentResult;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        component = getComponentOrPromiseFromMapper(props);
                        // If it's not a promise, return.
                        // Nothing to assure.

                        if (!(component.type === 'component')) {
                            _context3.next = 3;
                            break;
                        }

                        return _context3.abrupt('return');

                    case 3:
                        if (component.value) {
                            _context3.next = 5;
                            break;
                        }

                        return _context3.abrupt('return');

                    case 5:
                        if (!entityCache.has(component.value)) {
                            _context3.next = 7;
                            break;
                        }

                        return _context3.abrupt('return');

                    case 7:
                        _context3.next = 9;
                        return component.value();

                    case 9:
                        entityComponentResult = _context3.sent;

                        // We save the entity in the cache.
                        if ((typeof entityComponentResult === 'undefined' ? 'undefined' : (0, _typeof3.default)(entityComponentResult)) === 'object' && typeof entityComponentResult.default !== 'undefined') {
                            entityCache.set(component.value, entityComponentResult.default);
                        } else {
                            entityCache.set(component.value, entityComponentResult);
                        }

                    case 11:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));
}
/**
 * Returns the component if it is availible right now.
 * Returns null if the component isn't available, and never will be.
 * Returns undefined if the component isn't available, but maybe will be in the future.
 */
function getComponentFromMapper(props) {
    var entityComponent = getComponentOrPromiseFromMapper(props);
    if (entityComponent.type === 'promise' && typeof entityComponent.value !== 'undefined') {
        return entityCache.get(entityComponent.value);
    }
    if (entityComponent.type === 'component') {
        return entityComponent.value || null;
    }
    return null;
}
function getBundle(entity) {
    return getNested(function () {
        return entity.__hn.entity.type + '__' + entity.__hn.entity.bundle;
    }, '_fallback');
}
//# sourceMappingURL=EntityMapper.js.map
